import { render } from "./Dashboard.vue?vue&type=template&id=e87b66e6&scoped=true&ts=true"
import script from "./Dashboard.vue?vue&type=script&lang=ts"
export * from "./Dashboard.vue?vue&type=script&lang=ts"

import "./Dashboard.vue?vue&type=style&index=0&id=e87b66e6&scoped=true&lang=css"

import exportComponent from "/Users/rickvanwell/Work/Signals/webui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e87b66e6"]])

export default __exports__